import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=c8a0ff7c&"
import script from "./Highlights.vue?vue&type=script&lang=ts&"
export * from "./Highlights.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports